import { Navigate } from 'react-router-dom';

import { useAuthStore } from '../store/authStore';

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { token, requiresPasswordReset } = useAuthStore();
  if (!token) return <Navigate to="/login" replace />;
  if (requiresPasswordReset) return <Navigate to="/reset-password" replace />;
  return <>{children}</>;
};
